import { useContext, useEffect, useRef, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import useActas from "../../../api/actas";
import useEventos from "../../../api/eventosApi";
import { ContainerScreenGeneral, MuniSpinner2, Table } from "../../../components";
import { SearchIcon } from "../../../components/Icons";
import { UserContext } from "../../../context";
import { useEventosStore } from "../../../store/eventosStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import ModalActaDetalle from "../../../views/modals/ModalActaDetalle";
import ModalDetalleEvento from "../../../views/modals/ModalDetalleEvento";
import { filtrarEventos } from "./handlers";
import {
  errorLogsTableData,
  jobsLogsTableData,
  totalAuditsActaTableData,
  totalAuditsUsuarioTableData,
  userActasAnuladastableData,
  userActasTableData,
} from "./tableData";
import Table2 from "../../../components/Table2";

const Auditoria = () => {
  const [order, setOrder] = useState("asc");
  const [orderField, setOrderField] = useState("created_at");
  const [filtersFileds, setFiltersField] = useState({
    email: "",
    numero_acta: "",
    created_at: "",
  });

  const intervalIdRef = useRef(null);
  const { actions } = useContext(UserContext);

  //? ESTADOS GLOBALES
  const { modals, loads } = useGeneralAppStore();
  const {
    selectedEvent,
    selectedSubject,
    setSelectedEvent,
    setSelectedSubject,
    setFilteredEventos,
    eventos,
    eventosFiltrados,
    actaBuscar,
    setActaBuscar,
    usuarioBuscar,
    setUsuarioBuscar,
    isLoad,
  } = useEventosStore();

  //? LLAMADAS A LOS SERVICIOS
  const {
    getSelectedAudits,
    getErrorLogs,
    reloadAudits,
    getEventSelect,
    getActaAudits,
    getUsuarioAudits,
  } = useEventos();
  const { getActaDetalle } = useActas();

  const handleGetActaAudits = (actaBuscada) => {
    if (actaBuscada === "") return null;
    setSelectedSubject("totalAuditsActa");

    getActaAudits({
      subject_type: "totalAuditsActa",
      log_name: selectedEvent,
      numero_acta: actaBuscada,
    });
  };

  const handleGetUsuarioAudits = (usuarioBuscado) => {
    if (usuarioBuscado === "") return null;
    setSelectedSubject("totalAuditsUsuario");

    getUsuarioAudits({
      subject_type: "totalAuditsUsuario",
      log_name: selectedEvent,
      value: usuarioBuscado,
    });
  };

  useEffect(() => {
    if (eventos) {
      const eventosFiltrados = filtrarEventos(eventos, filtersFileds, order, orderField);
      setFilteredEventos(eventosFiltrados);
    }
  }, [filtersFileds, order, orderField]);

  useEffect(() => {
    if (selectedEvent && selectedEvent === "error" && selectedSubject === "") {
      getErrorLogs({ log_name: selectedEvent });
    }

    if (selectedEvent && selectedEvent !== "error" && selectedSubject) {
      getSelectedAudits({ subject_type: selectedSubject, log_name: selectedEvent });
    }
  }, [selectedEvent, selectedSubject]);

  useEffect(() => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
    }

    if ((selectedEvent != "" || selectedSubject != "") && eventosFiltrados.length > 0) {
      intervalIdRef.current = setInterval(() => {
        reloadAudits({ last_log_id: eventosFiltrados[0].id, selectedEvent, selectedSubject });
      }, 5000);
    }

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
    };
  }, [selectedEvent, selectedSubject, eventosFiltrados, isLoad]);

  return (
    <ContainerScreenGeneral size={"full"} linkBack={"/menu-admin"}>
      <div className=" w-100  bg-white" style={{ minHeight: "80vh" }}>
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-2 mb-2">
            <Form.Select
              disabled={loads.includes("audits" || "acta_detalle")}
              defaultValue={selectedEvent}
              onChange={(e) => {
                setSelectedEvent(e.target.value);
              }}
              style={{ width: "fit-content" }}
            >
              <option disabled value="">
                Eventos
              </option>
              {actions.user().events?.log_names?.map((name, index) => {
                if (
                  actions.hasRole("admin") ||
                  (actions.hasRole("admin.app") && actions.hasPermission("JP") && name === "user")
                ) {
                  return (
                    <option key={index} value={name}>
                      {name}
                    </option>
                  );
                }
                return null;
              })}
            </Form.Select>
            <Form.Select
              disabled={loads.includes("audits" || "acta_detalle")}
              defaultValue={selectedSubject}
              hidden={selectedEvent === "error"}
              onChange={(e) => {
                setSelectedSubject(e.target.value);
              }}
              style={{ width: "fit-content" }}
            >
              <option value="">Sujetos</option>

              {/* si el evento seleccionado es 'user' muestro solamente aquellas opciones donde el subject_type incluye a App\\Models\\ */}
              {selectedEvent === "user" &&
                actions
                  .user()
                  .events?.subject_types?.filter((name) => name.value.includes("App\\Models"))
                  .map((name, index) => (
                    <option key={index} value={name.value}>
                      {name.label}
                    </option>
                  ))}

              {/* si el evento seleccionado es 'job' muestro solamente aquellas opciones donde el subject_type incluye a App\\Jobs\\ */}
              {selectedEvent === "job" &&
                actions
                  .user()
                  .events?.subject_types?.filter((name) => name.value.includes("App\\Jobs"))
                  .map((name, index) => (
                    <option key={index} value={name.value}>
                      {name.label}
                    </option>
                  ))}
            </Form.Select>
            {selectedEvent === "user" &&
              (selectedSubject === "App\\Models\\ActasFotoMulta" ||
                selectedSubject === "totalAuditsActa" ||
                selectedSubject === "totalAuditsUsuario") && (
                <>
                  {/* Buscadores individuales de actas o usuarios con eventos */}
                  <div className="d-flex gap-2">
                    <div className="vr d-none d-sm-block"></div>

                    <div className="d-flex gap-2">
                      {/* buscar total eventos por numero de acta */}
                      <form>
                        <InputGroup>
                          <Form.Control
                            disabled={loads.includes("audits" || "acta_detalle")}
                            placeholder="Buscar acta..."
                            onChange={(e) => setActaBuscar(e.target.value)}
                          />
                          <button
                            type="submit"
                            disabled={loads.includes("audits" || "acta_detalle") || !actaBuscar}
                            className="btn btn-primary"
                            onClick={() => handleGetActaAudits(actaBuscar)}
                          >
                            <SearchIcon />
                          </button>
                        </InputGroup>
                      </form>

                      {/* buscar total eventos por email o por dni que participe */}
                      <form>
                        <InputGroup>
                          <Form.Control
                            disabled={loads.includes("audits" || "acta_detalle")}
                            placeholder="Buscar usuario..."
                            onChange={(e) => setUsuarioBuscar(e.target.value)}
                          />
                          <button
                            type="submit"
                            disabled={loads.includes("audits" || "acta_detalle") || !usuarioBuscar}
                            className="btn btn-primary"
                            onClick={() => handleGetUsuarioAudits(usuarioBuscar)}
                          >
                            <SearchIcon />
                          </button>
                        </InputGroup>
                      </form>
                    </div>
                  </div>
                </>
              )}
          </div>
        </div>

        <section className="position-relative ">
          {/* spinners de carga */}
          {loads.includes("audits") && (
            <div
              className="d-flex justify-content-center align-items-center position-absolute w-100 h-100 z-3"
              style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            >
              <MuniSpinner2 />
            </div>
          )}
          {loads.includes("audits_totales") && (
            <div
              className="d-flex justify-content-center align-items-center position-absolute w-100 h-100 z-3"
              style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            >
              <MuniSpinner2 />
            </div>
          )}
          {loads.includes("acta_detalle") && (
            <div
              className="d-flex justify-content-center align-items-center position-absolute w-100 h-100 z-3"
              style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            >
              <MuniSpinner2 />
            </div>
          )}

          {/* tabla evento: user &&  sujeto: actas */}
          {selectedEvent === "user" &&
            selectedSubject === "App\\Models\\ActasFotoMulta" &&
            eventosFiltrados && (
              <div className="mt-2 ">
                <Table2
                  height={"70vh"}
                  loading={loads.includes("audits")}
                  data={userActasTableData(
                    eventosFiltrados,
                    getEventSelect,
                    getActaDetalle,
                    setFiltersField,
                    setOrder,
                    setOrderField
                  )}
                />
              </div>
            )}

          {/* tabla evento: user &&  sujeto: actas anuladas */}
          {selectedEvent === "user" &&
            selectedSubject === "App\\Models\\MotivoAnulacion" &&
            eventosFiltrados && (
              <div className="mt-2">
                <Table2
                  height={"70vh"}
                  loading={loads.includes("audits")}
                  data={userActasAnuladastableData(
                    eventosFiltrados,
                    getEventSelect,
                    getActaDetalle,
                    setFiltersField,
                    setOrder,
                    setOrderField
                  )}
                />
              </div>
            )}

          {/* tabla evento: error  */}
          {selectedEvent === "error" && selectedSubject === "" && eventosFiltrados && (
            <div className="mt-2">
              <Table2
              height={"70vh"}
                loading={loads.includes("audits")}
                data={errorLogsTableData(
                  eventosFiltrados,
                  getEventSelect,
                  setFiltersField,
                  setOrder,
                  setOrderField
                )}
              />
            </div>
          )}

          {/* tabla evento: job  */}
          {selectedEvent === "job" &&
            (selectedSubject === "App\\Jobs\\GenerarActaFisica" ||
              selectedSubject === "App\\Jobs\\GeneraRecibo") &&
            eventosFiltrados && (
              <div className="mt-2">
                <Table2
                  height={"70vh"}
                  loading={loads.includes("audits")}
                  data={jobsLogsTableData(
                    eventosFiltrados,
                    getEventSelect,
                    getActaDetalle,
                    setFiltersField,
                    setOrder,
                    setOrderField
                  )}
                />
              </div>
            )}

          {/* tabla evento: user && sujeto: totalAuditsActa && actaBuscada: numero_infraccion */}
          {/* sujeto: totalAuditsActa es a proposito para poder diferenciar */}
          {selectedEvent === "user" &&
            selectedSubject === "totalAuditsActa" &&
            eventosFiltrados && (
              <div className="mt-2">
                <Table2
                height={"70vh"}
                  loading={loads.includes("audits_totales")}
                  data={totalAuditsActaTableData(
                    eventosFiltrados,
                    getEventSelect,
                    setFiltersField,
                    setOrder,
                    setOrderField
                  )}
                />
              </div>
            )}

          {/* tabla evento: user && sujeto: totalAuditsUsuario && actaBuscada: numero_infraccion */}
          {/* sujeto: totalAuditsUsuario es a proposito para poder diferenciar */}
          {selectedEvent === "user" &&
            selectedSubject === "totalAuditsUsuario" &&
            eventosFiltrados && (
              <div className="mt-2">
                <Table2
                height={"70vh"}
                  loading={loads.includes("audits_totales")}
                  data={totalAuditsUsuarioTableData(
                    eventosFiltrados,
                    getEventSelect,
                    getActaDetalle,
                    setFiltersField,
                    setOrder,
                    setOrderField
                  )}
                />
              </div>
            )}
        </section>
      </div>
      {modals.includes("detalle-evento") && <ModalDetalleEvento />}
      {modals.includes("acta_detalle") && <ModalActaDetalle />}
    </ContainerScreenGeneral>
  );
};
export default Auditoria;
